module.exports = __webpack_public_path__ + "static/Djinni-8141dcc55cd7981ac45286ce88023548.jpg";